import { message } from 'antd';
import i18n from '../i18n';
import { SERVICE_MESSAGES } from './translationValues';

message.config({ maxCount: 1 });

const logger = err => {
  console.error("Error in network service : ", err.custommsg, err.message, err.response);
  if (err) {
    if (!err.response) {
      message.error(i18n.t(`SERVICE_MESSAGES:${SERVICE_MESSAGES.GENERAL_OOPS_ERROR.key}`, SERVICE_MESSAGES.GENERAL_OOPS_ERROR.value));
    }
  }

  if (err && err.response) {
    const { status } = err.response;
    switch (status) {
      case 400:
        if (err.response && err.response.data) {
          if (err.response.data.errors) {
            message.error(err.response.data.errors[0].description);
          }
        }
        break;
      case 422:
        if (err.response && err.response.data) {
          if (err.response.data.errors) {
            message.error(err.response.data.errors[0].description);
          }
        }
        break;
      case 404:
        if (err.response && err.response.data) {
          if (err.response.data.errors) {
            message.error(err.response.data.errors[0].description);
          }
        }
        break;
      case 500:
        message.error(i18n.t(`SERVICE_MESSAGES:${SERVICE_MESSAGES.GENERAL_OOPS_ERROR.key}`, SERVICE_MESSAGES.GENERAL_OOPS_ERROR.value));
        break;
      default:
        break;
    }
  }
};

export default logger;
